import { HttpClient, HttpResponseBase } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError as _observableThrow } from 'rxjs'
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators'
import {
    AddEditBookingModel,
    GetBranchByLocationModel,
    GetInformationBookingModel,
} from '../models/booking-request.model'
import {
    ApiResponse,
    BookingCheck,
    BookingTime,
    Branch,
    District,
    Product,
    ProductGroup,
    Province
} from '../models/booking-response.model'
import { BaseService } from '../shared/base.service'
import { MainService } from '../shared/main.service'
import { API, HANDSHAKE } from '../utils/constants'
import { OptionsType } from '../utils/handshake.model'
import { ConfigService } from './config.service'

@Injectable({
    providedIn: 'root',
})
export class BookingService {

    isHandShakeFlg: boolean;
    API_URL: string;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    // getAllProvince
    getProvince(): Observable<ApiResponse<Province[]>> {
        return this.http.get<ApiResponse<Province[]>>(
            this.API_URL + 'Booking/GetAllProvince'
        )
    }

    // getAllPositon
    getPositions(data: any = {}): Observable<any> {
        var url = this.API_URL + 'MasterList/CategoryGetMasterListByGroupCode';
        url = url.replace(/[?&]$/, "");
        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }
            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }
        return this.baseService.handShakeAndCall<any>(
            url,
            data,
            null,
            func,
            this.isHandShakeFlg
        )
    }

    // GetAllDistrictByProvinceId
    getDistrictByProvinceId(id: number): Observable<ApiResponse<District[]>> {
        let url_ = this.API_URL + 'Booking/GetAllDistrictByProvinceId';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { Id: id },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetAllProductGroups
    getProductGroups(
        branchCode: string,
    ): Observable<ApiResponse<ProductGroup[]>> {
        let url_ = this.API_URL + 'Booking/GetAllProductGroups';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { BranchCode: branchCode },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetBranchByLocation
    getBranchByLocation(
        model: GetBranchByLocationModel,
    ): Observable<ApiResponse<Branch[]>> {
        let url_ = this.API_URL + 'Booking/GetBranchByLocation';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetProductsByProductGroupId
    getProductsByProductGroupId(
        productGroupId: number,
    ): Observable<ApiResponse<Product[]>> {
        let url_ = this.API_URL + 'Booking/GetProductsByProductGroupId';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { ProductGroupId: productGroupId },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetInformationBooking
    getInformationBooking(model: GetInformationBookingModel): Observable<any> {
        let url_ = this.API_URL + 'Booking/GetInformationBooking';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            model,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // GetBookingTimesList
    getBookingTimesList(): Observable<ApiResponse<BookingTime[]>> {
        return this.http.get<ApiResponse<BookingTime[]>>(
            this.API_URL + 'Booking/GetBookingTimesList'
        )
    }

    // CheckBooking
    checkBooking(bookingModel: AddEditBookingModel,): Observable<ApiResponse<BookingCheck>> {
        let url_ = this.API_URL + 'Booking/CheckBooking';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            bookingModel,
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // CreateBooking
    createBooking(
        bookingModel: AddEditBookingModel,
    ): Observable<ApiResponse<BookingCheck>> {
        let url_ = this.API_URL + 'Booking/CreateBooking';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            bookingModel,
            null,
            func,
            this.isHandShakeFlg,
        )
    }
}